/* eslint-disable import/prefer-default-export */
import { ResGetAllProducts } from '../@types/product.api';
import { APIS, token } from './constant';

export const getAllProducts = (): Promise<ResGetAllProducts> => new Promise((resolve, reject) => {
  fetch(APIS.GET_ALL_PRODUCTS, {
    method: 'GET',
    headers: {
      accept: '*/*',
      apiKey: token,
    },
  })
    .then(async (res) => {
      if (res.status === 401) {
        sessionStorage.removeItem('token');
        reject(new Error('Authentication Failed'));
      }
      resolve({
        data: {
          prices: await res.json().then((value) => value.data),
          message: 'All products list Retrieved',
        },
        message: 'All products list Retrieved',
      });
    })
    .catch(() => {
      reject(new Error('Failed to retrieve product list'));
    });
});
